export default function WritingAnimation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="60"
      height="15"
      viewBox="0 0 90 36"
      className="text-primary scale-[2.5]"
    >
      <defs>
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_53_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.9899425;0.9899427;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_52_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.9712644;0.9712645;0.9899425;0.9899425;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_51_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.9525862;0.9525864;0.9712644;0.9712644;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_50_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.933908;0.9339082;0.9525862;0.9525862;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_49_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.9152299;0.91523;0.933908;0.933908;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_48_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.8965517;0.8965519;0.9152299;0.9152299;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_47_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.8778736;0.8778737;0.8965517;0.8965517;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_46_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.8591954;0.8591955;0.8778736;0.8778736;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_45_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.8405172;0.8405174;0.8591954;0.8591954;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_44_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.8218391;0.8218392;0.8405172;0.8405172;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_43_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.8031609;0.8031611;0.8218391;0.8218391;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_42_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.7844828;0.7844829;0.8031609;0.8031609;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_41_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.7658046;0.7658047;0.7844828;0.7844828;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_40_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.7471264;0.7471266;0.7658046;0.7658046;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_39_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.7284483;0.7284484;0.7471264;0.7471264;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_38_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.7097701;0.7097703;0.7284483;0.7284483;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_37_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.691092;0.6910921;0.7097701;0.7097701;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_36_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.6724138;0.6724139;0.691092;0.691092;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_35_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.6537356;0.6537358;0.6724138;0.6724138;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_34_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.6350575;0.6350576;0.6537356;0.6537356;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_33_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.6163793;0.6163795;0.6350575;0.6350575;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_32_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.5977011;0.5977013;0.6163793;0.6163793;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_31_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.579023;0.5790231;0.5977011;0.5977012;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_30_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.5603448;0.560345;0.579023;0.579023;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_29_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.5416667;0.5416668;0.5603448;0.5603448;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_28_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.5229885;0.5229886;0.5416667;0.5416667;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_27_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.5043103;0.5043105;0.5229885;0.5229885;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_26_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.4856322;0.4856323;0.5043103;0.5043103;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_25_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.466954;0.4669542;0.4856322;0.4856322;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_24_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.4482759;0.448276;0.466954;0.466954;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_23_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.4295977;0.4295978;0.4482759;0.4482759;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_22_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.4109195;0.4109197;0.4295977;0.4295977;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_21_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.3922414;0.3922415;0.4109195;0.4109195;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_20_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.3735632;0.3735634;0.3922414;0.3922414;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_19_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.3548851;0.3548852;0.3735632;0.3735632;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_18_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.3362069;0.336207;0.3548851;0.3548851;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_17_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.3175287;0.3175289;0.3362069;0.3362069;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_16_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.2988506;0.2988507;0.3175287;0.3175287;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.2801724;0.2801726;0.2988506;0.2988506;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.2614943;0.2614944;0.2801724;0.2801724;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.2428161;0.2428162;0.2614943;0.2614943;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.2241379;0.2241381;0.2428161;0.2428161;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.2054598;0.2054599;0.2241379;0.2241379;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1867816;0.1867818;0.2054598;0.2054598;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_9_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1681034;0.1681036;0.1867816;0.1867816;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_8_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1494253;0.1494254;0.1681034;0.1681034;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_7_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1307471;0.1307473;0.1494253;0.1494253;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_6_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.112069;0.1120691;0.1307471;0.1307471;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_5_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.0933908;0.0933909;0.112069;0.112069;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_4_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.0747126;0.0747128;0.0933908;0.0933908;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.0560345;0.0560346;0.0747126;0.0747126;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.0373563;0.0373565;0.0560345;0.0560345;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.0186782;0.0186783;0.0373563;0.0373563;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="29s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.0186782;0.0186782;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="29s" from="0" to="1" xlinkHref="#time_group" />
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_53_G_M">
          <g id="_R_G_L_53_G">
            <path
              id="_R_G_L_53_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_53_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_53_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_52_G_M">
          <g id="_R_G_L_52_G">
            <path
              id="_R_G_L_52_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_52_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_52_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_51_G_M">
          <g id="_R_G_L_51_G">
            <path
              id="_R_G_L_51_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_51_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_51_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_50_G_M">
          <g id="_R_G_L_50_G">
            <path
              id="_R_G_L_50_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_50_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_50_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_49_G_M">
          <g id="_R_G_L_49_G">
            <path
              id="_R_G_L_49_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_49_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_49_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_48_G_M">
          <g id="_R_G_L_48_G">
            <path
              id="_R_G_L_48_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_48_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_48_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_47_G_M">
          <g id="_R_G_L_47_G">
            <path
              id="_R_G_L_47_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_47_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_47_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_46_G_M">
          <g id="_R_G_L_46_G">
            <path
              id="_R_G_L_46_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_46_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_46_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_45_G_M">
          <g id="_R_G_L_45_G">
            <path
              id="_R_G_L_45_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_45_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_45_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_44_G_M">
          <g id="_R_G_L_44_G">
            <path
              id="_R_G_L_44_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_44_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_44_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_43_G_M">
          <g id="_R_G_L_43_G">
            <path
              id="_R_G_L_43_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_43_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_43_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_42_G_M">
          <g id="_R_G_L_42_G">
            <path
              id="_R_G_L_42_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_42_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_42_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_41_G_M">
          <g id="_R_G_L_41_G">
            <path
              id="_R_G_L_41_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_41_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_41_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_40_G_M">
          <g id="_R_G_L_40_G">
            <path
              id="_R_G_L_40_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_40_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_40_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_39_G_M">
          <g id="_R_G_L_39_G">
            <path
              id="_R_G_L_39_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_39_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_39_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_38_G_M">
          <g id="_R_G_L_38_G">
            <path
              id="_R_G_L_38_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_38_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_38_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_37_G_M">
          <g id="_R_G_L_37_G">
            <path
              id="_R_G_L_37_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_37_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_37_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_36_G_M">
          <g id="_R_G_L_36_G">
            <path
              id="_R_G_L_36_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_36_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_36_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_35_G_M">
          <g id="_R_G_L_35_G">
            <path
              id="_R_G_L_35_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_35_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_35_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_34_G_M">
          <g id="_R_G_L_34_G">
            <path
              id="_R_G_L_34_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_34_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_34_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_33_G_M">
          <g id="_R_G_L_33_G">
            <path
              id="_R_G_L_33_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_33_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_33_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_32_G_M">
          <g id="_R_G_L_32_G">
            <path
              id="_R_G_L_32_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_32_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_32_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_31_G_M">
          <g id="_R_G_L_31_G">
            <path
              id="_R_G_L_31_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_31_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_31_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_30_G_M">
          <g id="_R_G_L_30_G">
            <path
              id="_R_G_L_30_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_30_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_30_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_29_G_M">
          <g id="_R_G_L_29_G">
            <path
              id="_R_G_L_29_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_29_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_29_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_28_G_M">
          <g id="_R_G_L_28_G">
            <path
              id="_R_G_L_28_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_28_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_28_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_27_G_M">
          <g id="_R_G_L_27_G">
            <path
              id="_R_G_L_27_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_27_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_27_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_26_G_M">
          <g id="_R_G_L_26_G">
            <path
              id="_R_G_L_26_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_26_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_26_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_25_G_M">
          <g id="_R_G_L_25_G">
            <path
              id="_R_G_L_25_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_25_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_25_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_24_G_M">
          <g id="_R_G_L_24_G">
            <path
              id="_R_G_L_24_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_24_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_24_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_23_G_M">
          <g id="_R_G_L_23_G">
            <path
              id="_R_G_L_23_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_23_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_23_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_22_G_M">
          <g id="_R_G_L_22_G">
            <path
              id="_R_G_L_22_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_22_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_22_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_21_G_M">
          <g id="_R_G_L_21_G">
            <path
              id="_R_G_L_21_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_21_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_21_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_20_G_M">
          <g id="_R_G_L_20_G">
            <path
              id="_R_G_L_20_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_20_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_20_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_19_G_M">
          <g id="_R_G_L_19_G">
            <path
              id="_R_G_L_19_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_19_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_19_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_18_G_M">
          <g id="_R_G_L_18_G">
            <path
              id="_R_G_L_18_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_18_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_18_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_17_G_M">
          <g id="_R_G_L_17_G">
            <path
              id="_R_G_L_17_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_17_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_17_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_16_G_M">
          <g id="_R_G_L_16_G">
            <path
              id="_R_G_L_16_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_16_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_16_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_15_G_M">
          <g id="_R_G_L_15_G">
            <path
              id="_R_G_L_15_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_15_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_15_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_14_G_M">
          <g id="_R_G_L_14_G">
            <path
              id="_R_G_L_14_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_14_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_14_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_13_G_M">
          <g id="_R_G_L_13_G">
            <path
              id="_R_G_L_13_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_13_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_13_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_12_G_M">
          <g id="_R_G_L_12_G">
            <path
              id="_R_G_L_12_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_12_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_12_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_11_G_M">
          <g id="_R_G_L_11_G">
            <path
              id="_R_G_L_11_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_11_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_11_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_10_G_M">
          <g id="_R_G_L_10_G">
            <path
              id="_R_G_L_10_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_10_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_10_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_9_G_M">
          <g id="_R_G_L_9_G">
            <path
              id="_R_G_L_9_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_9_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_9_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_8_G_M">
          <g id="_R_G_L_8_G">
            <path
              id="_R_G_L_8_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_8_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_8_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_7_G_M">
          <g id="_R_G_L_7_G">
            <path
              id="_R_G_L_7_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_7_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_7_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_6_G_M">
          <g id="_R_G_L_6_G">
            <path
              id="_R_G_L_6_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_6_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_6_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_5_G_M">
          <g id="_R_G_L_5_G">
            <path
              id="_R_G_L_5_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_5_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_5_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_4_G_M">
          <g id="_R_G_L_4_G">
            <path
              id="_R_G_L_4_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_4_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_4_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_3_G_M">
          <g id="_R_G_L_3_G">
            <path
              id="_R_G_L_3_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_3_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_3_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_2_G_M">
          <g id="_R_G_L_2_G">
            <path
              id="_R_G_L_2_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_2_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_2_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 12 C63.31,12 66,14.69 66,18 C66,21.31 63.31,24 60,24 C56.69,24 54,21.31 54,18 C54,14.69 56.69,12 60,12z "
            />
          </g>
        </g>
        <g id="_R_G_L_1_G_M">
          <g id="_R_G_L_1_G">
            <path
              id="_R_G_L_1_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 13 C32.76,13 35,15.24 35,18 C35,20.76 32.76,23 30,23 C27.24,23 25,20.76 25,18 C25,15.24 27.24,13 30,13z "
            />
            <path
              id="_R_G_L_1_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 12 C48.31,12 51,14.69 51,18 C51,21.31 48.31,24 45,24 C41.69,24 39,21.31 39,18 C39,14.69 41.69,12 45,12z "
            />
            <path
              id="_R_G_L_1_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
        <g id="_R_G_L_0_G_M">
          <g id="_R_G_L_0_G">
            <path
              id="_R_G_L_0_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M30 12 C33.31,12 36,14.69 36,18 C36,21.31 33.31,24 30,24 C26.69,24 24,21.31 24,18 C24,14.69 26.69,12 30,12z "
            />
            <path
              id="_R_G_L_0_G_D_1_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M45 13 C47.76,13 50,15.24 50,18 C50,20.76 47.76,23 45,23 C42.24,23 40,20.76 40,18 C40,15.24 42.24,13 45,13z "
            />
            <path
              id="_R_G_L_0_G_D_2_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M60 13 C62.76,13 65,15.24 65,18 C65,20.76 62.76,23 60,23 C57.24,23 55,20.76 55,18 C55,15.24 57.24,13 60,13z "
            />
          </g>
        </g>
      </g>
      <g id="time_group" />
    </svg>
  )
}
